<template>
  <div class="mainPage">
    <div class="header_banner">
      <div class="imgBg">
        <img src="../img/harmonious2025/m/banner1@2x.png" alt="" />
      </div>
      <div class="infoCon">
        <div class="centerBg">
          <img
            src="../img/harmonious2025/m/title 1@2x.png"
            alt=""
            class="left"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="rightBox">
        <div class="projectProfile">
          <!-- <img src="../img/chineseCultureVideoExhibition/m_icon3.png" alt="" class="icon3"> -->
          <div class="box">
            <div class="text">
              “君子和而不同”，“天地合而万物生”。数千年来，中华文明与不同文明相遇相知、交融互鉴，共祈和平愿景、合书盛世华章。在此，我们邀您共赏《中国神话故事（精编版）》《良渚（精编版）》《中国式现代化之路（精编版）》《美美与共（精编版）》等中央广播电视总台出品的多语种精品节目，在感受中华文化的独特魅力、领略世界文明百花园的绚丽光彩中，跨越国界，倾听和平发展、命运与共的时代回响！

              <p>精彩节目，陆续上新，敬请期待！</p>
            </div>
            <div class="text2">
              For thousands of years, Chinese civilization and different
              civilizations have met and known each other, blended and learned
              from each other, co-praying for a vision of peace, and co-creating
              glorious chapters in prosperous eras. Here, we invite you to enjoy
              CCTV/CGTN’s multilingual premium programs, including
              <span class="xt">
                Chinese Mythological Stories, Liangzhu, The Path to
                Modernization, Harmony in Diversity </span
              >. In experiencing the unique charm of Chinese culture and
              appreciating the splendid colors of the world's civilizations
              garden, we transcend national boundaries and listen to the echoes
              of the times that call for peaceful development and shared
              destiny!
              <p>
                More fantastic programs are coming up. Stay tuned!
              </p>
            </div>
          </div>
          <div
            class="theme_intro_footer"
            ref="themeIntro"
            :class="{ 'is-fixed': isThemeIntroFixed }"
          >
            <div class="theme_intro_footer_left">
              <div class="theme_intro_footer_title">
                <div class="theme_intro_footer_title_top">节目语种</div>
                <div class="theme_intro_footer_title_bottom">
                  Language
                </div>
              </div>
            </div>
            <div class="theme_intro_footer_right">
              <div
                class="lang_tab"
                :class="{ active: activeLang === '中文' }"
                @click="switchLang('中文')"
              >
                中文
              </div>
              <div
                class="lang_tab"
                :class="{ active: activeLang === 'English' }"
                @click="switchLang('English')"
              >
                English
              </div>
              <div
                class="lang_tab"
                :class="{ active: activeLang === 'Русский' }"
                @click="switchLang('Русский')"
              >
                Русский
              </div>
              <div
                class="lang_tab"
                :class="{ active: activeLang === 'Казахский' }"
                @click="switchLang('Казахский')"
              >
                Казахский
              </div>
              <div
                class="lang_tab"
                :class="{ active: activeLang === 'Español' }"
                @click="switchLang('Español')"
              >
                Español
              </div>
              <div
                class="lang_tab"
                :class="{ active: activeLang === 'Português Brasileiro' }"
                @click="switchLang('Português Brasileiro')"
              >
                Português Brasileiro
              </div>
              <div
                class="lang_tab"
                :class="{ active: activeLang === 'Français' }"
                @click="switchLang('Français')"
              >
                Français
              </div>
            </div>
          </div>
          <!-- <img src="../img/chineseCultureVideoExhibition/m_icon4.png" alt="" class="icon4"> -->
        </div>
        <div class="classBox_wrap">
          <div
            class="classBox"
            v-for="subject in subject_info"
            :key="subject.id"
            :ref="subject.id"
            :id="'lang-' + getSubjectLanguage(subject)"
            :data-lang="getSubjectLanguage(subject)"
          >
            <div class="classBox1">
              <div class="titleBox" :id="'t' + subject.id">
                <!-- <img :src="subject.extra.schoolLogo" alt=""> -->
              </div>
              <!-- 手机端视频集合 -->
              <div v-if="subject.type == 1" class="swiper_wrap">
                <div class="swiper_con">
                  <swiper
                    class="swiper gallery-top"
                    :options="swiperOptionTop"
                    ref="swiperTop"
                  >
                    <swiper-slide
                      v-for="(v, index) in subject.courseList"
                      :key="index"
                    >
                      <div
                        class="video_con"
                        :data-info="v.name"
                        @click="goDetail(subject, index)"
                      >
                        <div class="video_cover">
                          <img
                            :src="v.cover_url"
                            :alt="v.video_url"
                            class="cover"
                          />
                          <!-- <div class="playBtn" @click="replay(v.video_url, v.cover_url)">
                          <img src="../img/chineseCultureVideoExhibition/m_playIcon.png" alt="">
                        </div> -->
                        </div>
                        <!-- 视频标题 -->
                        <!-- <div class="titleBox1">
                        <div class="course_title">
                          <div class="cn">{{ v.name }}</div>
                          <div class="en">{{ v.name_en }}</div>
                        </div>
                      </div> -->
                      </div>
                    </swiper-slide>
                    <!-- 占位：当没有课程数据时，保留与视频区域等高的位置，避免布局塌陷 -->
                    <div
                      v-if="
                        !subject.courseList || subject.courseList.length === 0
                      "
                      class="swiper_placeholder"
                    ></div>
                    <div
                      class="swiper-pagination swiper-pagination-bullets"
                      slot="pagination"
                    ></div>
                  </swiper>
                  <div class="info_left">
                    <div class="serise_icon_con">
                      <img
                        :src="subject.image_url"
                        alt=""
                        class="look_detail_icon"
                      />
                    </div>
                    <div class="name_con">
                      <p class="cn">{{ subject.name }}</p>
                      <p class="en">{{ subject.name_en }}</p>
                    </div>
                  </div>
                </div>
                <div class="text_wrap">
                  <div class="swiper_page"></div>
                  <div class="text_cn">
                    {{ subject.describe }}
                  </div>
                  <!-- <div class="text_en">
                    {{ subject.describe_en }}
                  </div> -->
                </div>
              </div>
              <!-- 手机端文字介绍合集 -->
              <!-- <div class="series_type2_con" v-if="subject.type == 2">
                <div class="cover_con">
                  <img
                    :src="subject.courseList[0].cover_url"
                    alt=""
                    class="cover"
                    v-if="subject.courseList && subject.courseList.length"
                  />
                </div>
                <div class="des_con">
                  <p class="cn">{{ subject.describe }}</p>
                  <p class="en">{{ subject.describe_en }}</p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <!-- <div class="copy">版权所有 © 中央广播电视总台 中文联盟</div> -->
      <!-- <div class="bottomBg"></div>
			<img src="../img/chineseCultureVideoExhibition/new_2024/m_footer.png" alt=""> -->
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <video
              :src="currentVideoUrl"
              id="liveVideo"
              controls
              autoplay
              controlsList="nodownload"
            ></video>
          </div>
        </div>
      </div>
    </transition>

    <div
      id="menuGuide"
      v-show="isShowGuide"
      @click="showDirectory()"
      @mousewheel.prevent
    ></div>
  </div>
</template>

<script>
import Qs from "qs";
import language from "./common/language";
export default {
  name: "chinesebridge",
  components: {
    language,
  },
  metaInfo() {
    return {
      title: "2025和合之美，中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content: "2025和合之美，中央广播电视总台精品节目展播",
        },
        {
          name: "description",
          content: "2025和合之美，中央广播电视总台精品节目展播",
        },
      ],
    };
  },
  data: function() {
    return {
      isChrome: true,
      isLogin: false,
      isPlay: false,
      currentVideoUrl: "",
      user: {
        username: "",
        email: "",
      },
      lang: "cn",
      isShowGuide: false,
      active: 0,
      subject_info: [],
      courseList: {},
      activeTab: 0,
      subject_id: null,
      subject_name: [],
      subject_subText: [],
      activeLang: "中文", // 当前激活的语言

      //手机端
      swiperOptionTop: {
        // loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">${index +
              1}</span>`;
          },
        },
      },
      showDetail: false,
      languageList: [
        { type: "中文", alias: "yangshi2025-cn" },
        { type: "English", alias: "yangshi2025-en" },
        { type: "Русский", alias: "yangshi2025-ru" },
        { type: "Казахский", alias: "yangshi2025-ka" },
        { type: "Español", alias: "yangshi2025-sp" },
        { type: "Português Brasileiro", alias: "yangshi2025-bp" },
        { type: "Français", alias: "yangshi2025-fr" },
      ],
      isThemeIntroFixed: false,
      themeIntroInitialTop: 0,
      isProgrammaticScrolling: false,
      programmaticTargetTop: 0,
      programmaticTargetLang: "",
    };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
  created() {
    // 专题获取数据
    this.getCollectList();
  },
  mounted() {
    this.customCheckLogin();
    this.checkChrome();
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll, false);
    // 刷新后强制回到页面顶部，并禁用浏览器的滚动恢复
    if (
      window &&
      window.history &&
      typeof window.history.scrollRestoration !== "undefined"
    ) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    this.$nextTick(() => {
      if (this.$refs && this.$refs.themeIntro) {
        const rect = this.$refs.themeIntro.getBoundingClientRect();
        this.themeIntroInitialTop = rect.top + window.pageYOffset;
      }
      this.onScroll();
      window.addEventListener("resize", this.onResize, false);
    });

    let activeTab = this.$route.query.tab;
    if (activeTab) {
      this.activeTab = activeTab;
    }
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
    // 可按需恢复浏览器默认滚动恢复
    if (
      window &&
      window.history &&
      typeof window.history.scrollRestoration !== "undefined"
    ) {
      window.history.scrollRestoration = "auto";
    }
  },
  methods: {
    onResize() {
      if (this.$refs && this.$refs.themeIntro) {
        const rect = this.$refs.themeIntro.getBoundingClientRect();
        this.themeIntroInitialTop = rect.top + window.pageYOffset;
        this.onScroll();
      }
    },
    onScroll() {
      const y =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (!this.themeIntroInitialTop) {
        if (this.$refs && this.$refs.themeIntro) {
          const rect = this.$refs.themeIntro.getBoundingClientRect();
          this.themeIntroInitialTop = rect.top + window.pageYOffset;
        }
      }
      this.isThemeIntroFixed = y >= this.themeIntroInitialTop;

      // 程序化滚动期间：到达目标前跳过 scrollspy，避免中途错误高亮
      if (this.isProgrammaticScrolling) {
        if (Math.abs(y - this.programmaticTargetTop) <= 2) {
          this.isProgrammaticScrolling = false;
          if (this.programmaticTargetLang) {
            this.activeLang = this.programmaticTargetLang;
          }
        } else {
          return;
        }
      }

      // ScrollSpy：根据滚动位置联动高亮当前语言
      try {
        const sections = document.querySelectorAll(".classBox[data-lang]");
        if (sections && sections.length) {
          const offset = this.getThemeIntroOffset() || 0;
          const viewportTop = y + offset + 1; // +1 防止临界抖动
          let currentLang = this.activeLang;
          sections.forEach((sec) => {
            const attr = sec.getAttribute("data-lang");
            if (!attr) return;
            const r = sec.getBoundingClientRect();
            const absTop =
              r.top +
              (window.pageYOffset || document.documentElement.scrollTop || 0);
            if (absTop <= viewportTop) {
              currentLang = attr;
            }
          });
          if (currentLang && currentLang !== this.activeLang) {
            this.activeLang = currentLang;
          }
        }
      } catch (e) {
        // 忽略异常
      }
    },
    // 切换语言并跳转到对应内容区域
    switchLang(lang) {
      this.activeLang = lang; // 更新当前激活的语言

      // 跳转到对应语言的classBox
      this.scrollToLanguage(lang);
    },

    // 跳转到指定语言的classBox
    scrollToLanguage(lang) {
      // 通过data-lang属性查找对应的classBox
      const targetElement = document.querySelector(
        `.classBox[data-lang="${lang}"]`
      );
      if (targetElement) {
        // 计算目标位置并以程序化滚动方式前往，避免联动闪烁
        const rect = targetElement.getBoundingClientRect();
        const absoluteTop =
          rect.top +
          (window.pageYOffset || document.documentElement.scrollTop || 0);
        const offset = this.getThemeIntroOffset() || 0;
        const targetY = Math.max(absoluteTop - offset, 0);
        this.isProgrammaticScrolling = true;
        this.programmaticTargetTop = targetY;
        this.programmaticTargetLang = lang;
        window.scrollTo({ top: targetY, behavior: "smooth" });
      }
    },

    // 获取系列的语言类型
    getSubjectLanguage(subject) {
      // 从系列数据中获取语言类型，字段为alias，默认为中文
      return this.resolveLanguageName(subject && subject.alias) || "中文";
    },

    // 将 alias 映射为显示语言名
    resolveLanguageName(alias) {
      const list = this.languageList || [];
      if (!alias) return "";
      const found = list.find(
        (item) => item.alias === alias || item.type === alias
      );
      return (found && found.type) || "";
    },

    // 纯函数：按固定 alias 顺序返回新的已排序数组，避免多次渲染
    sortByAlias(list) {
      const orderedAliases = "yangshi2025-cn,yangshi2025-en,yangshi2025-ru,yangshi2025-ka,yangshi2025-sp,yangshi2025-bp,yangshi2025-fr"
        .split(",")
        .map((s) => s.trim());
      const rank = {};
      orderedAliases.forEach((a, i) => (rank[a] = i));
      return (Array.isArray(list) ? [...list] : []).sort((a, b) => {
        const ra = Object.prototype.hasOwnProperty.call(rank, a && a.alias)
          ? rank[a.alias]
          : Number.MAX_SAFE_INTEGER;
        const rb = Object.prototype.hasOwnProperty.call(rank, b && b.alias)
          ? rank[b.alias]
          : Number.MAX_SAFE_INTEGER;
        return ra - rb;
      });
    },

    // 按固定 alias 顺序重排 subject_info
    reorderSubjects() {
      const orderedAliases = "yangshi2025-cn,yangshi2025-en,yangshi2025-ru,yangshi2025-ka,yangshi2025-sp,yangshi2025-bp,yangshi2025-fr"
        .split(",")
        .map((s) => s.trim());
      const rank = {};
      orderedAliases.forEach((a, i) => (rank[a] = i));
      const list = Array.isArray(this.subject_info) ? this.subject_info : [];
      list.sort((a, b) => {
        const ra = Object.prototype.hasOwnProperty.call(rank, a && a.alias)
          ? rank[a.alias]
          : Number.MAX_SAFE_INTEGER;
        const rb = Object.prototype.hasOwnProperty.call(rank, b && b.alias)
          ? rank[b.alias]
          : Number.MAX_SAFE_INTEGER;
        return ra - rb;
      });
      this.subject_info = list;
    },

    // 登录
    toLogin() {
      window.location.href =
        this.baseUrl +
        "user/api/login?" +
        "callback=" +
        encodeURIComponent(window.location.href);
    },
    // 注册
    toRegister() {
      window.location.href =
        "https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=" +
        encodeURIComponent(window.location.href);
    },
    // 检查是否登录 获取用户信息
    customCheckLogin() {
      this.checkLogin()
        .then((res) => {
          if (res.data.success) {
            this.isLogin = true;
            this.user = res.data.data;
          } else {
            this.isLogin = false;
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },
    // 退出登录
    toLogOut() {
      this.$utils.get("/user/api/logout").then((res) => {
        if (res.data.success) {
          this.isLogin = false;
        }
      });
    },
    showDirectory() {
      this.isShowGuide = !this.isShowGuide;
    },
    goDetail(item, i) {
      this.$router.push({
        path: "/m_page/m_hm2025_detail",
        query: {
          collection_id: item.id,
          videoIndex: i,
        },
      });
      this.showDetail = true;
    },
    getCollectList() {
      this.$utils
        .get("/subject/lesson_Collection/getlist", {
          limit: 999,
          alias:
            "yangshi2025-cn,yangshi2025-en,yangshi2025-ru,yangshi2025-ka,yangshi2025-sp,yangshi2025-bp,yangshi2025-fr",
        })
        .then((res) => {
          if (res.data.success) {
            const rawList = res.data.data.list || [];
            this.subject_info = this.sortByAlias(rawList);
            this.getAllInfo();
          }
        });
    },
    async getAllInfo() {
      this.subject_info.forEach((item) => {
        // if (item.type == 1) {
        this.getSubjectInfo(item);
        // }
      });
    },

    getSubjectInfo(item) {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: item.id,
          order: "sort",
          limit: 30,
        })
        .then((res) => {
          if (res.data.success) {
            item.courseList = res.data.data.list;
            this.$forceUpdate();
          }
        });
    },

    //排序
    compare(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },

    goAnchor(selector, index) {
      this.active = index;
      const el = this.$el.querySelector("#" + selector);
      if (el) {
        this.scrollToElementWithOffset(el);
      }
    },

    //播放课程
    replay(url, cover) {
      // console.log(url)
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function() {
        //
        $("#liveVideo").bind("contextmenu", function() {
          return false;
        }); //为video添加禁止右键另存为操作
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    },
    // 计算吸顶栏高度作为滚动偏移
    getThemeIntroOffset() {
      const bar = this.$refs && this.$refs.themeIntro;
      const barHeight = bar && bar.offsetHeight ? bar.offsetHeight : 0;
      // 如果页面还有其他固定头部，可在此叠加
      return barHeight;
    },
    // 平滑滚动到元素位置，考虑吸顶栏高度偏移
    scrollToElementWithOffset(el) {
      const rect = el.getBoundingClientRect();
      const absoluteTop =
        rect.top +
        (window.pageYOffset || document.documentElement.scrollTop || 0);
      const offset = this.getThemeIntroOffset();
      const targetY = Math.max(absoluteTop - offset, 0);
      window.scrollTo({ top: targetY, behavior: "smooth" });
    },
    checkChrome() {
      var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
      if (!isChrome) {
        this.isChrome = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.xt {
  font-style: italic;
}
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  // background-color: #ebf0f9;
  // background: linear-gradient(to right, #def3fd61, #ffdae23d);
  user-select: none;
  overflow: hidden;
  background: url("../img/chineseCultureVideoExhibition2025/m/content_bg.png")
    no-repeat center;

  .agentTip {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #ffe6a1;
    text-align: center;
    position: absolute;
    z-index: 5;
    color: #c40000;
  }

  .agentTip .closeTip {
    position: absolute;
    right: 24px;
    top: 0px;
    font-size: 30px;
    color: #282828;
    cursor: pointer;
  }

  .header_banner {
    // position: relative;
    // background-image: url(../img/chineseCultureVideoExhibition/m_banner.png);
    // height: 285px;
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-position: center;

    .imgBg {
      max-width: 100%;
      height: auto;
      position: absolute;
      z-index: -1;

      img {
        width: 100%;
      }
    }

    header {
      position: absolute;
      height: 50px;
      line-height: 50px;
      z-index: 2;
      // border-bottom: 1px solid rgba(#fff, 0.3);
      top: 0;
      width: 100%;
      margin: auto;
      color: #fff;

      .center {
        color: #8590cc;
        width: 90%;
        margin: auto;

        a {
          color: #8590cc;
          margin-right: 15px;
          // opacity: 0.8;
        }
      }

      .left {
        float: left;
      }

      .right {
        line-height: 50px;
        float: right;

        img {
          vertical-align: text-top;
          margin-right: 15px;
        }

        .loginCon {
          display: inline-block;
          margin-left: 30px;

          span {
            cursor: pointer;
          }

          .username {
            margin-right: 12px;
          }
        }
      }
    }

    .infoCon {
      .centerBg {
        width: 88%;
        margin: auto;

        img {
          margin-top: 25px;
          max-width: 97%;
          height: auto;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    // max-width: 1400px;
    // height: 2860px;
    margin: auto;
    // margin-top: -125px;

    .leftBox {
      position: fixed;
      // width: 65%;
      top: 50px;
      right: 0px;
      background-color: #fff;
      border-radius: 5px 0 0 5px;
      box-shadow: -5px 5px 20px 0px #888888;
      text-align: end;
      z-index: 10000;

      .box {
        display: flex;
        flex-direction: column;
        margin-right: 30px;
        margin-left: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        // animation: my-animation1 0.5s ease-in-out;
        // @keyframes my-animation1 {
        // 	0% { transform: scale(.5); }
        // 	100% { transform: scale(1); }
        // }

        .titleBox {
          // padding: 7px 10px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          cursor: pointer;

          .title {
            padding: 7px 10px;
            display: flex;
            flex-direction: column;
            margin-right: 45px;

            .title_cn {
              font-size: 18px;
              line-height: 30px;
            }

            .title_en {
              font-size: 12px;
              font-family: DINCond-Medium;
            }
          }

          // .icon {
          // 	width: 30px;
          // 	height: 30px;
          // 	display: none;
          // }
        }

        .titleBox.active {
          .title {
            color: darkorange;
            margin-right: 45px;
          }

          // .icon {
          // 	display: block;
          // }
        }
      }

      .icon {
        position: absolute;
        bottom: 57px;
        right: 15px;
        width: 40px;
        height: 0px;

        img {
          width: 100%;
        }
      }
    }

    .icon1 {
      position: absolute;
      // bottom: 18px;
      top: 420px;
      right: 10px;
      width: 50px;
      height: 50px;
      z-index: 9999;

      // animation: my-animation 0.5s ease-in-out;
      // @keyframes my-animation {
      // 		0% { transform: scale(.5); }
      // 		100% { transform: scale(1); }
      // 	}
      img {
        width: 100%;
      }
    }

    .rightBox {
      width: 100%;
      display: flex;
      flex-direction: column;
      // text-align: left;

      .projectProfile {
        position: relative;
        margin-top: 9px;
        // background: url(../img/chineseCultureVideoExhibition2025/m/kuang.png)
        // no-repeat center;
        // background-size: 100% 100%;
        .icon3 {
          width: 55%;
          position: absolute;
          left: 0px;
          top: 0px;
        }

        .icon4 {
          width: 55%;
          position: absolute;
          right: 20px;
          bottom: 30px;
        }

        .kuang1 {
          position: absolute;
          margin-top: 10px;
          z-index: 100;
        }

        .box {
          width: 100%;
          border-radius: 10px;
          background-color: #fdfbfb;
          opacity: 1;
        }

        .theme_intro_footer {
          position: sticky;
          top: 0;
          z-index: 10050;
          width: 100%;
          height: 1.2rem;
          display: flex;
          margin-top: 0.4rem;
          border-radius: 0.2rem;
          overflow: visible;

          &.is-fixed {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 10050;
            margin-top: 0;
            border-radius: 0;
            // 提高可见性，避免与内容混在一起
            background: #fff3d2;
          }

          .theme_intro_footer_left {
            width: 100px !important;
            min-width: 100px !important;
            max-width: 100px !important;
            height: 1.2rem;
            background: #ffd667 !important;
            display: flex;
            align-items: center;
            justify-content: center;

            .theme_intro_footer_title {
              text-align: center;

              .theme_intro_footer_title_top {
                font-family: Inter, Inter;
                font-weight: 400;
                font-size: 0.32rem;
                color: #000000;
                line-height: 1.2;
                margin-bottom: 0.05rem;
              }

              .theme_intro_footer_title_bottom {
                font-family: Inter, Inter;
                font-weight: 400;
                font-size: 0.2rem;
                color: #000000;
                line-height: 1.2;
              }
            }
          }

          .theme_intro_footer_right {
            position: relative;
            flex: 1;
            height: 1.2rem;
            background: #fff3d2;
            overflow-x: auto;
            overflow-y: hidden;
            display: flex;
            align-items: center;
            padding: 0 20px;
            column-gap: 0.2rem;

            /* 隐藏滚动条但保持滚动功能 */
            &::-webkit-scrollbar {
              display: none;
            }
            -ms-overflow-style: none;
            scrollbar-width: none;

            .lang_tab {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 0.24rem;
              color: #000000;
              cursor: pointer;
              position: relative;
              transition: all 0.3s;
              padding: 0 0.2rem;
              text-align: center;
              white-space: nowrap;
              flex-shrink: 0;
              height: 1.2rem;
              display: flex;
              align-items: center;
              justify-content: center;

              &.active {
                color: #ff0000;
                font-weight: bold;

                &::after {
                  content: "";
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 2px;
                  background-color: #ff0000;
                }
              }

              &:hover {
                color: #ff0000;
              }

              // 移除固定宽度，使用column-gap保证等间距
            }
          }
        }
      }

      .text {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-size: 15px;
        color: #000000;
        padding-top: 15px;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 15px;
        line-height: 20px;
        text-align: justify;
        text-indent: 2em;
      }

      .text2 {
        font-size: 14px;
        color: #282828;
        padding-left: 15px;
        padding-right: 15px;
        line-height: 20px;
        padding-bottom: 15px;
        text-align: justify;
        // text-indent:2em;
      }
    }
  }

  .classBox {
    position: relative;
    padding: 0;
    // margin-top: 0.5rem;
    // border-radius: 12px 12px 12px 12px;

    .titleBox {
      width: auto;
      height: 1.2rem;
      position: absolute;
      z-index: 10;
      top: -0.8rem;
      left: -0.1rem;

      img {
        width: auto;
        height: 100%;
      }
    }

    .text {
      margin-top: 1.3rem;
      padding: 10px 15px 20px;
      text-align: justify;
    }

    .text_cn {
      font-size: 0.3rem;
      color: #5e696d;
      line-height: 24px;
      margin-top: 0.5rem;
      margin-bottom: 5px;
      text-align: left;
      text-indent: 2em;
    }

    .text_en {
      font-size: 0.3rem;
      color: #5e696d;
      line-height: 20px;
      text-align: left;
    }

    .info_left {
      position: absolute;
      left: 0.3rem;
      right: 0.3rem;
      top: 3.64rem;
      z-index: 10000;
      display: flex;
      align-items: flex-start;
      .serise_icon_con {
        border: solid 0.03rem #ffffff;
        flex-shrink: 0;
        img {
          border-radius: 6px;
          width: 1.5rem;
          height: 1.5rem;
          display: block;
        }
      }
      .name_con {
        flex: 1;
        margin-top: 0.4rem;
        margin-left: 0.25rem;
        text-align: left;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
        .cn {
          font-family: SourceHanSansCN;
          font-weight: bold;
          font-size: 0.4rem;
          color: #364347;
          margin-bottom: 0.1rem;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: anywhere;
          line-height: 0.5rem;
        }
        .en {
          font-family: SourceHanSansCN;
          font-weight: bold;
          font-size: 0.26rem;
          color: #93a4aa;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: anywhere;
          line-height: 0.2rem;
        }
      }
    }
    .swiper_wrap {
      background-color: #fff;
      border-radius: 0.1rem;
      .swiper_con {
        margin-left: 0rem;
        position: relative;
        padding: 0 0.2rem;
        .swiper_placeholder {
          width: 100%;
          height: 4rem;
          background: transparent;
        }

        .swiper-container {
          position: unset;
        }

        .swiper ::v-deep {
          .swiper-slide {
            .swiperBox {
              overflow: hidden;
            }
          }

          .video_con {
            width: 100%;
            box-sizing: border-box;
            padding: 0;

            .video_cover {
              width: 100%;
              aspect-ratio: 16 / 9;
              background-color: #ffae00;

              img {
                display: block;
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }

            .playBtn {
              position: absolute;
              width: 0.8rem;
              height: 0.9rem;
              bottom: 1rem;
              right: 0.4rem;
              z-index: 10;
              animation: my-animation 1.5s ease-in-out infinite;

              @keyframes my-animation {
                0% {
                  transform: scale(0.8);
                }

                50% {
                  transform: scale(1);
                }

                100% {
                  transform: scale(0.8);
                }
              }
            }

            .titleBox1 {
              position: absolute;
              height: 55px;
              margin-top: -55px;
              width: 100%;
              color: #fff;
              background-color: #55565775;
              text-align: left;
              bottom: 0;
              z-index: 100;
              display: flex;
              align-items: center;

              .course_title {
                padding: 10px 20px;

                .cn {
                  font-size: 16px;
                }

                .en {
                  margin-top: 4px;
                  font-size: 14px;
                }
              }
            }
          }

          .video_con2 {
            width: 1rem;
            background-color: #c40000;

            .checkBox {
              width: 1rem;
              height: 1rem;
              background-color: #ffae00;
            }
          }
          .swiper-pagination {
            position: static !important;
            margin-top: 1.7rem;
            left: auto;
            right: auto;
          }
          .swiper-pagination-bullets {
            bottom: auto;
            text-align: left;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-left: 10px;

            .swiper-pagination-bullet-custom {
              border-radius: 0.14rem;
              border: 1px solid #ba9f7d;
              width: 0.7rem !important;
              height: 0.7rem !important;
              line-height: 0.7rem !important;
              text-align: center;
              color: #a1896b;
              background-image: linear-gradient(0deg, #e7d9ce 0%, #f8f4f1 100%);
              transition: all 0.5s;
              margin-right: 0.1rem;
              margin-top: 4px;
              opacity: 1;

              &.swiper-pagination-bullet-active {
                opacity: 1;
                color: #eb7f66;
                border: solid 1px #eb7f66;
                background: rgba(#fceeeb, 0.6);
              }
            }
          }
        }

        .gallery-top {
          width: 100%;
          height: auto;
        }

        .gallery-thumbs {
          height: 20%;
          box-sizing: border-box;
          width: 1rem;
        }

        .gallery-thumbs .swiper-slide {
          height: 100%;
          opacity: 0.4;
          width: 1rem !important;
        }

        .gallery-thumbs .swiper-slide-active {
          opacity: 1;
        }

        .swiper-button-prev {
          background-image: url(../img/chineseCultureVideoExhibition/prev.png);
          position: absolute;
          left: -75px;
          top: 90px;
        }

        .swiper-button-next {
          background-image: url(../img/chineseCultureVideoExhibition/next.png);
          right: -75px;
          top: 90px;
        }
      }
      .text_wrap {
        padding: 0 0.3rem 0.4rem 0.3rem;
      }
    }

    .series_type2_con {
      overflow: hidden;
      background-color: #fff;
      border-radius: 0.1rem;

      .cover_con {
        width: 10.28rem;
        height: 5.8rem;
        display: block;
        margin-right: 22px;
      }
      .cover {
        display: block;
        width: 100%;
        height: 100%;
      }
      .des_con {
        font-size: 0.3rem;
        color: #5e696d;
        line-height: 1;
        text-align: left;
        margin-top: 0.5rem;
        padding: 0 0.3rem 0.4rem 0.3rem;

        .cn {
          text-indent: 2em;
          margin-bottom: 0.2rem;
          margin-top: 0.2rem;
          display: -webkit-box; /* 必须设置，用于多行溢出 */
          -webkit-box-orient: vertical; /* 设置盒子排列方向为垂直 */
          -webkit-line-clamp: 4; /* 限制显示的行数，例如显示 3 行 */
          line-clamp: 4; /* 标准属性，增强兼容性 */
          overflow: hidden; /* 隐藏超出的内容 */
        }
        .en {
          display: -webkit-box; /* 必须设置，用于多行溢出 */
          -webkit-box-orient: vertical; /* 设置盒子排列方向为垂直 */
          -webkit-line-clamp: 5; /* 限制显示的行数，例如显示 3 行 */
          line-clamp: 5; /* 标准属性，增强兼容性 */
          overflow: hidden; /* 隐藏超出的内容 */
        }
      }
    }
  }
}

.footer {
  margin-top: 1rem;
  margin-bottom: 0.8rem;
  font-size: 0.24rem;
  .copy {
    // position: absolute;
    // bottom: 70px;
    width: 100%;
    text-align: center;
    font-weight: 600;
  }

  img {
    width: 100%;
  }
}

#videoPlayWrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.88);
  z-index: 9999;
}

#menuGuide {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}

#videoPlayWrapper .closeVideo {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 50px;
  color: #fff;
  cursor: pointer;
}

.videoContent {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.videoContainer {
  text-align: center;
  width: 100%;
}

.videoContainer video {
  width: 100%;
}

video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
